var React = require('react');

function ProfileCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"13","r":"10.2","fillRule":"evenodd","clipRule":"evenodd","fill":"#fff","key":0}),React.createElement("path",{"d":"M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 6.9c2.1 0 3.8 1.7 3.8 3.8 0 2.1-1.7 3.8-3.8 3.8s-3.8-1.7-3.8-3.8c0-2.1 1.7-3.8 3.8-3.8zM5.4 18.7v.6c1.7 1.6 4 2.5 6.6 2.5s4.8-1 6.6-2.5v-.6c0-1.6-1.3-2.9-2.9-2.9H8.3c-1.6 0-2.9 1.3-2.9 2.9z","fillRule":"evenodd","clipRule":"evenodd","key":1})]);
}

ProfileCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ProfileCircle;

ProfileCircle.default = ProfileCircle;
